import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const goal: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[200]};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-direction: row;
    align-items: center;
  }
`;

export const goalDetail: ThemedFunctor = () => css`
  flex-grow: 1;
`;
export const goalMetrics: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[200]};
  flex-wrap: wrap;
  padding-top: ${theme.remSize[200]};
  border-top: 1px solid ${theme.color.border.neutral.default.low};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    align-items: center;
    gap: ${theme.remSize[300]};
    padding: 0 0 0 ${theme.remSize[300]};
    border-top: 0;
    border-left: 1px solid ${theme.color.border.neutral.default.low};
    flex-shrink: 0;
  }
`;

export const metric: ThemedFunctor = ({ theme }) => css`
  flex-basis: calc(50% - ${theme.remSize[100]});

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    min-width: 6.25rem;
    flex-basis: auto;
  }
`;
